import Vue from 'vue'
import VueRouter from 'vue-router'

import Page from '@/components/Page'
import NotFound from '@/components/NotFound'
import store from './../store';

Vue.use(VueRouter)

const Router = new VueRouter({
	mode: 'history',
	base: __dirname,
	routes: [
		{
			path: '/',
			name: 'Page',
			component: Page
		},
		{
			path: '*',
			component: NotFound
		}],
	// scrollBehavior(to, from, savedPosition) {
	// 	console.log('scrollBehavior');
	// 	console.log(to);
	// 	console.log(from);
	// 	console.log(savedPosition);
	//
	// 	if (savedPosition) {
	//     return savedPosition
	//   } else {
	//     const position = {}
	//
	//     // scroll to anchor by returning the selector
	//     if (to.hash) {
	//       position.selector = to.hash
	//
	//       if (document.querySelector(to.hash)) {
	//         return position
	//       }
	//
	//       // if the returned position is falsy or an empty object,
	//       // will retain current scroll position.
	//       return false
	//     }
	//
	//     return new Promise(resolve => {
	//       // check if any matched route config has meta that requires scrolling to top
	//       if (to.matched.some(m => m.meta.scrollToTop)) {
	//         // coords will be used if no selector is provided,
	//         // or if the selector didn't match any element.
	//         position.x = 0
	//         position.y = 0
	//       }
	//
	//       // wait for the out transition to complete (if necessary)
	//       // this.app.$root.$once('triggerScroll', () => {
	//       //   // if the resolved position is falsy or an empty object,
	//       //   // will retain current scroll position.
	//       //   resolve(position)
	//       // })
	//     })
	//   }
	// }
})

export default Router;



// WEBPACK FOOTER //
// ./src/router/index.js